export const test = () => {

	// Prevent clicking on link with current href
	var links = document.querySelectorAll('a[href]');
	
	var cbk = function(e) {

		if(e.currentTarget.href === window.location.href) {
			e.preventDefault();
			e.stopPropagation();
		}

	};

	for(var i = 0; i < links.length; i++) {
		links[i].addEventListener('click', cbk);
	}

	// TOGGLE GRID
	if(document.querySelector('.grid')){

		var wrapper = document.getElementById('grid');
		var visible = false;
		
		document.body.onkeypress = function(e){

		    if(e.key == "g" && !visible){
		        wrapper.classList.add('visible');
		        visible = true;
		    } else if(e.key == "g" && visible){
		        wrapper.classList.remove('visible');
		        visible = false;
		    }
		}
	}
	
}